import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Paper } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";

const useStyles = makeStyles(theme => ({
	tagsContainer: {
		border: "none",
		boxShadow: "none",
		minHeight: 32, // Altura mínima fixa igual ao container real
		display: "flex",
		alignItems: "center",
		padding: "2px 12px 6px 12px",
		boxSizing: "border-box",
		backgroundColor: theme.palette.background.paper,
		gap: theme.spacing(0.5),
	},
}));

const TagsContainerSkeleton = () => {
	const classes = useStyles();

	return (
		<Paper className={classes.tagsContainer}>
			<Skeleton animation="wave" variant="circle" width={16} height={16} style={{ marginRight: 8 }} />
			<Skeleton animation="wave" variant="rect" width="100%" height={24} style={{ borderRadius: 12 }} />
		</Paper>
	);
};

export default TagsContainerSkeleton;